import { connect } from 'react-redux';
import LoadMore from '../../../components/common/LoadMore';
import { loadMore } from '../actions';
import { isLoadingMore } from '../selectors';

const mapStateToProps = state => ({
  showSpinner: isLoadingMore(state)
});

const mapDispatchToProps = {
  onClick: loadMore
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadMore);
